import { MEDIA_URL } from "../constants/api";

export const getImageUrl = (path) => {
  if (!path) return "";
  if (path.startsWith("http://") || path.startsWith("https://")) return path;
  return `${MEDIA_URL}/${path}`;
};
